import {
  DocumentData,
  QueryDocumentSnapshot,
  SnapshotOptions,
} from "firebase/firestore";
import { ContactOption, FSScenario, Scenario } from "../types/scenario.types";

const recordToMap = (inputRecord?: Record<ContactOption, string[]>) => {
  const contactSettingsMap = new Map<ContactOption, string[]>();
  if (!inputRecord) return contactSettingsMap;
  Object.entries(inputRecord).forEach(([key, value]) => {
    contactSettingsMap.set(key as ContactOption, value);
  });
  return contactSettingsMap;
};

export const scenarioConverter = {
  toFirestore(scenario: Scenario): DocumentData {
    const contactSettings = scenario.contactSettings
      ? Object.fromEntries(scenario.contactSettings)
      : undefined;
    const contactGroupSettings = scenario.contactGroupSettings
      ? Object.fromEntries(scenario.contactGroupSettings)
      : undefined;
    return {
      ...scenario,
      contactSettings,
      contactGroupSettings,
    };
  },

  fromFirestore(
    snapshot: QueryDocumentSnapshot<FSScenario>,
    options: SnapshotOptions
  ): Scenario {
    const scenario = snapshot.data(options)!;
    return {
      ...scenario,
      contactSettings: recordToMap(scenario.contactSettings),
      contactGroupSettings: recordToMap(scenario.contactGroupSettings),
    };
  },
};
